import { PropsWithChildren } from 'react'
import { twMerge } from 'tailwind-merge'

type SettingsSectionHeadingProps = PropsWithChildren & { className?: string }

function SettingsSectionHeading({ children, className }: SettingsSectionHeadingProps) {
  return (
    <h3 className={twMerge('flex items-center', className)}>
      <span className="max-w-full truncate">{children}</span>
      <span className="border-fill-primary ml-6 h-px flex-1 border-t-2" />
    </h3>
  )
}

export default SettingsSectionHeading
